import { createAsyncAction, createAction } from 'typesafe-actions';
import { TimeZonesDto } from '../dtos/timeZones';

export const getTimeZonesActions = createAsyncAction(
  'GET_TIMEZONES_REQUEST',
  'GET_TIMEZONES_SUCCESS',
  'GET_TIMEZONES_ERROR',
)<undefined, TimeZonesDto[], string>();

export const timeZonesShouldRefresh = createAction('REFRESH_TIME_ZONES')<boolean>();